webpackJsonp([238537616139720],{

/***/ 1511:
/***/ (function(module, exports) {

	module.exports = {"pathContext":{"name":"PriceChangeFilterInput","kind":"INPUT_OBJECT","type":"OBJECT","fields":[{"defaultValue":null,"description":null,"name":"allSelected","type":{"kind":"NON_NULL","name":null,"ofType":{"kind":"SCALAR","name":"Boolean","ofType":null}}},{"defaultValue":null,"description":null,"name":"excludeSelected","type":{"kind":"NON_NULL","name":null,"ofType":{"kind":"SCALAR","name":"Boolean","ofType":null}}},{"defaultValue":null,"description":null,"name":"ids","type":{"kind":"LIST","name":null,"ofType":{"kind":"SCALAR","name":"ID","ofType":null}}},{"defaultValue":null,"description":null,"name":"type","type":{"kind":"NON_NULL","name":null,"ofType":{"kind":"ENUM","name":"PriceChangeFilterType","ofType":null}}},{"defaultValue":null,"description":null,"name":"values","type":{"kind":"LIST","name":null,"ofType":{"kind":"SCALAR","name":"String","ofType":null}}}],"description":null,"enumValues":null,"possibleTypes":null}}

/***/ })

});


// WEBPACK FOOTER //
// path---input-object-price-change-filter-input-3f1a52b6ce44108607ca.js